<template>
    <div class="px-5">
        <v-dialog v-model="aiOverviewDialog" max-width="500">
            <v-card>
                <v-card-title class="headline">AI Overview Tracking</v-card-title>
                <v-card-text> Enabling AI Overview tracking will consume <b>twice the keyword tracking credits</b> due to the asynchronous loading required. </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="aiOverviewDialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="pb-4 qgreycard">
            <div class="quarolbl pb-2" style="font-weight: bold">
                PROJECT TITLE
                <v-tooltip max-width="250" color="" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>The "Project Title" field specifies the title of your monitoring project. </span>
                </v-tooltip>
            </div>
            <v-text-field type="text" rounded filled v-model="project.title" hint="e.g. Apple Phone Prompts" persistent-hint></v-text-field>
        </div>

        <div class="pb-2 qgreycard">
            <div class="quarolbl pb-2" style="font-weight: bold">
                YOUR BRAND
                <v-tooltip max-width="250" color="" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>Select the focus domain you want to monitor.</span>
                </v-tooltip>
            </div>

            <!-- <v-autocomplete
                rounded
                filled
                hint="e.g. Apple, Samsung"
                persistent-hint
                v-model="selectedEntity"
                :items="entitySuggestions"
                item-text="name"
                item-value="uniqueKey"
                return-object
                :search-input.sync="entitySearchText"
                label="Your Brand"
                :loading="entityLoading"
            >
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle v-if="data.item.description">{{ data.item.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete> -->
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field rounded filled v-model="project.brand.brand_name" label="Brand Name" hint="e.g. Apple" persistent-hint></v-text-field>
                </v-col>
                <v-col cols="12" md="6"> <v-text-field rounded filled v-model="project.brand.brand_domain" label="Brand Domain" hint="e.g. apple.com" persistent-hint></v-text-field> </v-col
            ></v-row>
        </div>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="pb-4 qgreycard mt-0">
                    <div class="quarolbl pb-2" style="font-weight: bold">
                        PLATFORMS
                        <v-tooltip max-width="250" color="" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lighten-2">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>Select one or more AI platforms for your project.</span>
                        </v-tooltip>
                    </div>
                    <v-select
                        v-model="project.platforms"
                        :items="platformSelectItems"
                        item-text="label"
                        item-value="key"
                        label="Select Platforms"
                        multiple
                        rounded
                        filled
                        persistent-hint
                        hint="Choose one or more AI platforms for tracking">
                        <template v-slot:item="{ item, on, attrs }">
                            <v-list-item v-on="on" v-bind="attrs" style="cursor: pointer" :disabled="item.status != 'active' || item.disabled === true">
                                <span v-if="item.logo" v-html="item.logo" style="height: 22px; width: 22px; margin-right: 10px; display: inline-block; vertical-align: middle" />
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.label }}
                                        <v-chip class="ml-2" v-if="item.status != 'active'" small>{{ item.status }}</v-chip>
                                        <v-chip class="ml-2" v-if="item.disabled === true" small>unsupported</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                            <v-chip v-if="item" small>
                                <span v-if="item.logo" v-html="item.logo" style="height: 18px; width: 18px; border-radius: 3px; margin-right: 6px; display: inline-block; vertical-align: middle" />
                                {{ item.label }}
                            </v-chip>
                        </template>
                    </v-select>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <div class="pb-4 qgreycard mt-0">
                    <div class="quarolbl pb-2" style="font-weight: bold">
                        LOCATION
                        <v-tooltip max-width="250" color="" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>The "Location" field specifies the geographical location of the search results that will be analyzed. </span>
                        </v-tooltip>
                    </div>

                    <v-select
                        hide-details
                        :items="textMap"
                        :disabled="disabled"
                        rounded
                        v-model="project.langloc"
                        :item-text="getLocationText"
                        :item-value="getLocationKey"
                        prepend-inner-icon="mdi-map-marker"
                        return-object
                        filled
                        attach
                        :menu-props="{ top: true, offsetY: true }">
                    </v-select>
                </div>
            </v-col>
            <v-col cols="6">
                <div class="qgreycard mt-0">
                    <div class="quarolbl pb-1" style="font-weight: bold">
                        Update Interval
                        <v-tooltip max-width="250" color="" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2">mdi-help-circle-outline</v-icon>
                            </template>
                            <span>The "Update Interval" specifies if the rankings of your project will be updated every day, once a week, every two weeks or once a month.</span>
                        </v-tooltip>
                    </div>
                    <v-chip-group class="py-0" color="primary" column show-arrows v-model="intervalFilter" return-object mandatory next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left">
                        <v-chip v-for="(interval, i) in intervalTexts" :key="i" filter close-icon="mdi-close-circle-outline" filter-icon="mdi-check-circle">
                            <span style="text-transform: capitalize"> {{ interval }}</span>
                        </v-chip>
                    </v-chip-group>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import axios from "axios"
    import { AMAZON_RUFUS_LOGO, isAmazonRufusLocation } from "../../utils/platformMeta"
    export default {
        props: {
            project: Object
        },
        data() {
            return {
                platformSelectItems: [
                    {
                        key: "chatgpt",
                        label: "ChatGPT",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 509.639"><path fill="#fff" d="M115.612 0h280.775C459.974 0 512 52.026 512 115.612v278.415c0 63.587-52.026 115.613-115.613 115.613H115.612C52.026 509.64 0 457.614 0 394.027V115.612C0 52.026 52.026 0 115.612 0z"/><path fill-rule="nonzero" d="M412.037 221.764a90.834 90.834 0 004.648-28.67 90.79 90.79 0 00-12.443-45.87c-16.37-28.496-46.738-46.089-79.605-46.089-6.466 0-12.943.683-19.264 2.04a90.765 90.765 0 00-67.881-30.515h-.576c-.059.002-.149.002-.216.002-39.807 0-75.108 25.686-87.346 63.554-25.626 5.239-47.748 21.31-60.682 44.03a91.873 91.873 0 00-12.407 46.077 91.833 91.833 0 0023.694 61.553 90.802 90.802 0 00-4.649 28.67 90.804 90.804 0 0012.442 45.87c16.369 28.504 46.74 46.087 79.61 46.087a91.81 91.81 0 0019.253-2.04 90.783 90.783 0 0067.887 30.516h.576l.234-.001c39.829 0 75.119-25.686 87.357-63.588 25.626-5.242 47.748-21.312 60.682-44.033a91.718 91.718 0 0012.383-46.035 91.83 91.83 0 00-23.693-61.553l-.004-.005zM275.102 413.161h-.094a68.146 68.146 0 01-43.611-15.8 56.936 56.936 0 002.155-1.221l72.54-41.901a11.799 11.799 0 005.962-10.251V241.651l30.661 17.704c.326.163.55.479.596.84v84.693c-.042 37.653-30.554 68.198-68.21 68.273h.001zm-146.689-62.649a68.128 68.128 0 01-9.152-34.085c0-3.904.341-7.817 1.005-11.663.539.323 1.48.897 2.155 1.285l72.54 41.901a11.832 11.832 0 0011.918-.002l88.563-51.137v35.408a1.1 1.1 0 01-.438.94l-73.33 42.339a68.43 68.43 0 01-34.11 9.12 68.359 68.359 0 01-59.15-34.11l-.001.004zm-19.083-158.36a68.044 68.044 0 0135.538-29.934c0 .625-.036 1.731-.036 2.5v83.801l-.001.07a11.79 11.79 0 005.954 10.242l88.564 51.13-30.661 17.704a1.096 1.096 0 01-1.034.093l-73.337-42.375a68.36 68.36 0 01-34.095-59.143 68.412 68.412 0 019.112-34.085l-.004-.003zm251.907 58.621l-88.563-51.137 30.661-17.697a1.097 1.097 0 011.034-.094l73.337 42.339c21.109 12.195 34.132 34.746 34.132 59.132 0 28.604-17.849 54.199-44.686 64.078v-86.308c.004-.032.004-.065.004-.096 0-4.219-2.261-8.119-5.919-10.217zm30.518-45.93c-.539-.331-1.48-.898-2.155-1.286l-72.54-41.901a11.842 11.842 0 00-5.958-1.611c-2.092 0-4.15.558-5.957 1.611l-88.564 51.137v-35.408l-.001-.061a1.1 1.1 0 01.44-.88l73.33-42.303a68.301 68.301 0 0134.108-9.129c37.704 0 68.281 30.577 68.281 68.281a68.69 68.69 0 01-.984 11.545v.005zm-191.843 63.109l-30.668-17.704a1.09 1.09 0 01-.596-.84v-84.692c.016-37.685 30.593-68.236 68.281-68.236a68.332 68.332 0 0143.689 15.804 63.09 63.09 0 00-2.155 1.222l-72.54 41.9a11.794 11.794 0 00-5.961 10.248v.068l-.05 102.23zm16.655-35.91l39.445-22.782 39.444 22.767v45.55l-39.444 22.767-39.445-22.767v-45.535z"/></svg>`,
                        status: "active"
                    },
                    {
                        key: "gemini",
                        label: "Gemini",
                        logo: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65"><mask id="maskme" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="65" height="65"><path d="M32.447 0c.68 0 1.273.465 1.439 1.125a38.904 38.904 0 001.999 5.905c2.152 5 5.105 9.376 8.854 13.125 3.751 3.75 8.126 6.703 13.125 8.855a38.98 38.98 0 005.906 1.999c.66.166 1.124.758 1.124 1.438 0 .68-.464 1.273-1.125 1.439a38.902 38.902 0 00-5.905 1.999c-5 2.152-9.375 5.105-13.125 8.854-3.749 3.751-6.702 8.126-8.854 13.125a38.973 38.973 0 00-2 5.906 1.485 1.485 0 01-1.438 1.124c-.68 0-1.272-.464-1.438-1.125a38.913 38.913 0 00-2-5.905c-2.151-5-5.103-9.375-8.854-13.125-3.75-3.749-8.125-6.702-13.125-8.854a38.973 38.973 0 00-5.905-2A1.485 1.485 0 010 32.448c0-.68.465-1.272 1.125-1.438a38.903 38.903 0 005.905-2c5-2.151 9.376-5.104 13.125-8.854 3.75-3.749 6.703-8.125 8.855-13.125a38.972 38.972 0 001.999-5.905A1.485 1.485 0 0132.447 0z" fill="#000"/><path d="M32.447 0c.68 0 1.273.465 1.439 1.125a38.904 38.904 0 001.999 5.905c2.152 5 5.105 9.376 8.854 13.125 3.751 3.75 8.126 6.703 13.125 8.855a38.98 38.98 0 005.906 1.999c.66.166 1.124.758 1.124 1.438 0 .68-.464 1.273-1.125 1.439a38.902 38.902 0 00-5.905 1.999c-5 2.152-9.375 5.105-13.125 8.854-3.749 3.751-6.702 8.126-8.854 13.125a38.973 38.973 0 00-2 5.906 1.485 1.485 0 01-1.438 1.124c-.68 0-1.272-.464-1.438-1.125a38.913 38.913 0 00-2-5.905c-2.151-5-5.103-9.375-8.854-13.125-3.75-3.749-8.125-6.702-13.125-8.854a38.973 38.973 0 00-5.905-2A1.485 1.485 0 010 32.448c0-.68.465-1.272 1.125-1.438a38.903 38.903 0 005.905-2c5-2.151 9.376-5.104 13.125-8.854 3.75-3.749 6.703-8.125 8.855-13.125a38.972 38.972 0 001.999-5.905A1.485 1.485 0 0132.447 0z" fill="url(#prefix__paint0_linear_2001_67)"/></mask><g mask="url(#maskme)"><g filter="url(#prefix__filter0_f_2001_67)"><path d="M-5.859 50.734c7.498 2.663 16.116-2.33 19.249-11.152 3.133-8.821-.406-18.131-7.904-20.794-7.498-2.663-16.116 2.33-19.25 11.151-3.132 8.822.407 18.132 7.905 20.795z" fill="#FFE432"/></g><g filter="url(#prefix__filter1_f_2001_67)"><path d="M27.433 21.649c10.3 0 18.651-8.535 18.651-19.062 0-10.528-8.35-19.062-18.651-19.062S8.78-7.94 8.78 2.587c0 10.527 8.35 19.062 18.652 19.062z" fill="#FC413D"/></g><g filter="url(#prefix__filter2_f_2001_67)"><path d="M20.184 82.608c10.753-.525 18.918-12.244 18.237-26.174-.68-13.93-9.95-24.797-20.703-24.271C6.965 32.689-1.2 44.407-.519 58.337c.681 13.93 9.95 24.797 20.703 24.271z" fill="#00B95C"/></g><g filter="url(#prefix__filter3_f_2001_67)"><path d="M20.184 82.608c10.753-.525 18.918-12.244 18.237-26.174-.68-13.93-9.95-24.797-20.703-24.271C6.965 32.689-1.2 44.407-.519 58.337c.681 13.93 9.95 24.797 20.703 24.271z" fill="#00B95C"/></g><g filter="url(#prefix__filter4_f_2001_67)"><path d="M30.954 74.181c9.014-5.485 11.427-17.976 5.389-27.9-6.038-9.925-18.241-13.524-27.256-8.04-9.015 5.486-11.428 17.977-5.39 27.902 6.04 9.924 18.242 13.523 27.257 8.038z" fill="#00B95C"/></g><g filter="url(#prefix__filter5_f_2001_67)"><path d="M67.391 42.993c10.132 0 18.346-7.91 18.346-17.666 0-9.757-8.214-17.667-18.346-17.667s-18.346 7.91-18.346 17.667c0 9.757 8.214 17.666 18.346 17.666z" fill="#3186FF"/></g><g filter="url(#prefix__filter6_f_2001_67)"><path d="M-13.065 40.944c9.33 7.094 22.959 4.869 30.442-4.972 7.483-9.84 5.987-23.569-3.343-30.663C4.704-1.786-8.924.439-16.408 10.28c-7.483 9.84-5.986 23.57 3.343 30.664z" fill="#FBBC04"/></g><g filter="url(#prefix__filter7_f_2001_67)"><path d="M34.74 51.43c11.135 7.656 25.896 5.524 32.968-4.764 7.073-10.287 3.779-24.832-7.357-32.488C49.215 6.52 34.455 8.654 27.382 18.94c-7.072 10.288-3.779 24.833 7.357 32.49z" fill="#3186FF"/></g><g filter="url(#prefix__filter8_f_2001_67)"><path d="M54.984-2.336c2.833 3.852-.808 11.34-8.131 16.727-7.324 5.387-15.557 6.631-18.39 2.78-2.833-3.853.807-11.342 8.13-16.728 7.324-5.387 15.558-6.631 18.39-2.78z" fill="#749BFF"/></g><g filter="url(#prefix__filter9_f_2001_67)"><path d="M31.727 16.104C43.053 5.598 46.94-8.626 40.41-15.666c-6.53-7.04-21.006-4.232-32.332 6.274s-15.214 24.73-8.683 31.77c6.53 7.04 21.006 4.232 32.332-6.274z" fill="#FC413D"/></g><g filter="url(#prefix__filter10_f_2001_67)"><path d="M8.51 53.838c6.732 4.818 14.46 5.55 17.262 1.636 2.802-3.915-.384-10.994-7.116-15.812-6.731-4.818-14.46-5.55-17.261-1.636-2.802 3.915.383 10.994 7.115 15.812z" fill="#FFEE48"/></g></g><defs><filter id="prefix__filter0_f_2001_67" x="-19.824" y="13.152" width="39.274" height="43.217" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="2.46" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter1_f_2001_67" x="-15.001" y="-40.257" width="84.868" height="85.688" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="11.891" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter2_f_2001_67" x="-20.776" y="11.927" width="79.454" height="90.916" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="10.109" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter3_f_2001_67" x="-20.776" y="11.927" width="79.454" height="90.916" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="10.109" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter4_f_2001_67" x="-19.845" y="15.459" width="79.731" height="81.505" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="10.109" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter5_f_2001_67" x="29.832" y="-11.552" width="75.117" height="73.758" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="9.606" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter6_f_2001_67" x="-38.583" y="-16.253" width="78.135" height="78.758" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="8.706" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter7_f_2001_67" x="8.107" y="-5.966" width="78.877" height="77.539" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="7.775" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter8_f_2001_67" x="13.587" y="-18.488" width="56.272" height="51.81" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="6.957" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter9_f_2001_67" x="-15.526" y="-31.297" width="70.856" height="69.306" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="5.876" result="effect1_foregroundBlur_2001_67"/></filter><filter id="prefix__filter10_f_2001_67" x="-14.168" y="20.964" width="55.501" height="51.571" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="7.273" result="effect1_foregroundBlur_2001_67"/></filter><linearGradient id="prefix__paint0_linear_2001_67" x1="18.447" y1="43.42" x2="52.153" y2="15.004" gradientUnits="userSpaceOnUse"><stop stop-color="#4893FC"/><stop offset=".27" stop-color="#4893FC"/><stop offset=".777" stop-color="#969DFF"/><stop offset="1" stop-color="#BD99FE"/></linearGradient></defs></svg>`,
                        status: "active"
                    },
                    {
                        key: "perplexity",
                        label: "Perplexity",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 509.64"><path fill="#1F1F1F" d="M115.613 0h280.774C459.974 0 512 52.025 512 115.612v278.415c0 63.587-52.026 115.613-115.613 115.613H115.613C52.026 509.64 0 457.614 0 394.027V115.612C0 52.025 52.026 0 115.613 0z"/><path fill="#fff" fill-rule="nonzero" d="M348.851 128.063l-68.946 58.302h68.946v-58.302zm-83.908 48.709l100.931-85.349v94.942h32.244v143.421h-38.731v90.004l-94.442-86.662v83.946h-17.023v-83.906l-96.596 86.246v-89.628h-37.445V186.365h38.732V90.768l95.309 84.958v-83.16h17.023l-.002 84.206zm-29.209 26.616c-34.955.02-69.893 0-104.83 0v109.375h20.415v-27.121l84.415-82.254zm41.445 0l82.208 82.324v27.051h21.708V203.388c-34.617 0-69.274.02-103.916 0zm-42.874-17.023l-64.669-57.646v57.646h64.669zm13.617 124.076v-95.2l-79.573 77.516v88.731l79.573-71.047zm17.252-95.022v94.863l77.19 70.83c0-29.485-.012-58.943-.012-88.425l-77.178-77.268z"/></svg>`,
                        status: "active"
                    },
                    {
                        key: "grok",
                        label: "Grok",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" ><path d="M18.542 30.532l15.956-11.776c.783-.576 1.902-.354 2.274.545 1.962 4.728 1.084 10.411-2.819 14.315-3.903 3.901-9.333 4.756-14.299 2.808l-5.423 2.511c7.778 5.315 17.224 4 23.125-1.903 4.682-4.679 6.131-11.058 4.775-16.812l.011.011c-1.966-8.452.482-11.829 5.501-18.735C47.759 1.332 47.88 1.166 48 1l-6.602 6.599V7.577l-22.86 22.958M15.248 33.392c-5.582-5.329-4.619-13.579.142-18.339 3.521-3.522 9.294-4.958 14.331-2.847l5.412-2.497c-.974-.704-2.224-1.46-3.659-1.994-6.478-2.666-14.238-1.34-19.505 3.922C6.904 16.701 5.31 24.488 8.045 31.133c2.044 4.965-1.307 8.48-4.682 12.023C2.164 44.411.967 45.67 0 47l15.241-13.608"/></svg>`,
                        status: "active"
                    },
                    {
                        key: "google",
                        label: "AI Overviews",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                                    <linearGradient id="8sl3bbNtWcumaCBCPc4S6a_rnK88i9FvAFO_gr1" x1="3.906" x2="45.428" y1="3.906" y2="45.428" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ca5df5"></stop><stop offset=".036" stop-color="#c05ff4"></stop><stop offset=".293" stop-color="#806cea"></stop><stop offset=".528" stop-color="#4d77e3"></stop><stop offset=".731" stop-color="#297fdd"></stop><stop offset=".895" stop-color="#1283da"></stop><stop offset="1" stop-color="#0a85d9"></stop></linearGradient><path fill="url(#8sl3bbNtWcumaCBCPc4S6a_rnK88i9FvAFO_gr1)" d="M46.117,23.081l-0.995-0.04H45.12C34.243,22.613,25.387,13.757,24.959,2.88l-0.04-0.996	C24.9,1.39,24.494,1,24,1s-0.9,0.39-0.919,0.883l-0.04,0.996c-0.429,10.877-9.285,19.733-20.163,20.162l-0.995,0.04	C1.39,23.1,1,23.506,1,24s0.39,0.9,0.884,0.919l0.995,0.039c10.877,0.43,19.733,9.286,20.162,20.163l0.04,0.996	C23.1,46.61,23.506,47,24,47s0.9-0.39,0.919-0.883l0.04-0.996c0.429-10.877,9.285-19.733,20.162-20.163l0.995-0.039	C46.61,24.9,47,24.494,47,24S46.61,23.1,46.117,23.081z"></path>
                                    </svg>`,
                        status: "active"
                    },
                    {
                        key: "google_ai_mode",
                        label: "AI Mode",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path></svg>`,
                        status: "active"
                    },
                    {
                        key: "microsoft_copilot",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48"><path d="M34.142 7.325A4.63 4.63 0 0029.7 4H28.35a4.63 4.63 0 00-4.554 3.794L21.48 20.407l.575-1.965a4.63 4.63 0 014.444-3.33h7.853l3.294 1.282 3.175-1.283h-.926a4.63 4.63 0 01-4.443-3.325l-1.31-4.461z" fill="url(#prefix__paint0_radial_56201_15503)"/><path d="M14.33 40.656A4.63 4.63 0 0018.779 44h2.87a4.63 4.63 0 004.629-4.51l.312-12.163-.654 2.233a4.63 4.63 0 01-4.443 3.329h-7.919l-2.823-1.532-3.057 1.532h.912a4.63 4.63 0 014.447 3.344l1.279 4.423z" fill="url(#prefix__paint1_radial_56201_15503)"/><path d="M29.5 4H13.46c-4.583 0-7.332 6.057-9.165 12.113C2.123 23.29-.72 32.885 7.503 32.885h6.925a4.63 4.63 0 004.456-3.358 2078.617 2078.617 0 014.971-17.156c.843-2.843 1.544-5.284 2.621-6.805C27.08 4.714 28.086 4 29.5 4z" fill="url(#prefix__paint2_linear_56201_15503)"/><path d="M29.5 4H13.46c-4.583 0-7.332 6.057-9.165 12.113C2.123 23.29-.72 32.885 7.503 32.885h6.925a4.63 4.63 0 004.456-3.358 2078.617 2078.617 0 014.971-17.156c.843-2.843 1.544-5.284 2.621-6.805C27.08 4.714 28.086 4 29.5 4z" fill="url(#prefix__paint3_linear_56201_15503)"/><path d="M18.498 44h16.04c4.582 0 7.332-6.058 9.165-12.115 2.171-7.177 5.013-16.775-3.208-16.775h-6.926a4.63 4.63 0 00-4.455 3.358 2084.036 2084.036 0 01-4.972 17.16c-.842 2.843-1.544 5.285-2.62 6.806-.604.852-1.61 1.566-3.024 1.566z" fill="url(#prefix__paint4_radial_56201_15503)"/><path d="M18.498 44h16.04c4.582 0 7.332-6.058 9.165-12.115 2.171-7.177 5.013-16.775-3.208-16.775h-6.926a4.63 4.63 0 00-4.455 3.358 2084.036 2084.036 0 01-4.972 17.16c-.842 2.843-1.544 5.285-2.62 6.806-.604.852-1.61 1.566-3.024 1.566z" fill="url(#prefix__paint5_linear_56201_15503)"/><defs><radialGradient id="prefix__paint0_radial_56201_15503" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(-10.96051 -13.38922 12.59013 -10.30637 38.005 20.514)"><stop offset=".096" stop-color="#00AEFF"/><stop offset=".773" stop-color="#2253CE"/><stop offset="1" stop-color="#0736C4"/></radialGradient><radialGradient id="prefix__paint1_radial_56201_15503" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(51.84 -28.201 27.85) scale(15.9912 15.5119)"><stop stop-color="#FFB657"/><stop offset=".634" stop-color="#FF5F3D"/><stop offset=".923" stop-color="#C02B3C"/></radialGradient><radialGradient id="prefix__paint4_radial_56201_15503" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(109.274 16.301 20.802) scale(38.3873 45.9867)"><stop offset=".066" stop-color="#8C48FF"/><stop offset=".5" stop-color="#F2598A"/><stop offset=".896" stop-color="#FFB152"/></radialGradient><linearGradient id="prefix__paint2_linear_56201_15503" x1="12.5" y1="7.5" x2="14.788" y2="33.975" gradientUnits="userSpaceOnUse"><stop offset=".156" stop-color="#0D91E1"/><stop offset=".487" stop-color="#52B471"/><stop offset=".652" stop-color="#98BD42"/><stop offset=".937" stop-color="#FFC800"/></linearGradient><linearGradient id="prefix__paint3_linear_56201_15503" x1="14.5" y1="4" x2="15.75" y2="32.885" gradientUnits="userSpaceOnUse"><stop stop-color="#3DCBFF"/><stop offset=".247" stop-color="#0588F7" stop-opacity="0"/></linearGradient><linearGradient id="prefix__paint5_linear_56201_15503" x1="42.586" y1="13.346" x2="42.569" y2="21.215" gradientUnits="userSpaceOnUse"><stop offset=".058" stop-color="#F8ADFA"/><stop offset=".708" stop-color="#A86EDD" stop-opacity="0"/></linearGradient></defs></svg>`,
                        label: "Microsoft Copilot",
                        status: "active"
                    },
                    {
                        key: "amazon_rufus",
                        label: "Amazon Rufus",
                        logo: AMAZON_RUFUS_LOGO,
                        status: "active"
                    },
                    {
                        key: "openai",
                        label: "OpenAI API",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"  viewBox="0 0 48 48">
                        <linearGradient id="SVGID_1__JV8I2qAOf5Ts_gr1" x1="37.562" x2="10.438" y1="10.438" y2="37.561" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#60e8fe"></stop><stop offset=".033" stop-color="#6ae9fe"></stop><stop offset=".197" stop-color="#97f0fe"></stop><stop offset=".362" stop-color="#bdf5ff"></stop><stop offset=".525" stop-color="#dafaff"></stop><stop offset=".687" stop-color="#eefdff"></stop><stop offset=".846" stop-color="#fbfeff"></stop><stop offset="1" stop-color="#fff"></stop></linearGradient><path fill="url(#SVGID_1__JV8I2qAOf5Ts_gr1)" d="M40.475,20.803c0.774-2.528,0.53-5.23-0.722-7.583c-2.018-3.792-6.225-5.638-10.284-5.086	c-1.802-1.935-4.265-3.074-6.929-3.166c-4.294-0.149-7.996,2.572-9.547,6.363c-2.576,0.593-4.794,2.156-6.206,4.417	c-2.275,3.643-1.771,8.21,0.737,11.449c-0.774,2.528-0.53,5.23,0.722,7.583c2.018,3.792,6.225,5.638,10.284,5.086	c1.802,1.935,4.265,3.074,6.929,3.167c4.293,0.148,7.996-2.573,9.547-6.364c2.576-0.593,4.794-2.156,6.205-4.417	C43.487,28.607,42.983,24.041,40.475,20.803z"></path><path fill="#10cfe3" d="M38.844,17.559l-7.523-4.343c-0.493-0.284-1.1-0.285-1.594-0.003l-10.245,5.855l0.021-4.018l7.913-4.569	c3.445-1.989,7.938-1.371,10.44,1.722c0.594,0.734,1.04,1.539,1.341,2.382c0.211,0.592,0.772,0.984,1.4,0.984	c1.037,0,1.772-1.03,1.421-2.006c-0.416-1.158-1.033-2.265-1.853-3.275c-2.488-3.065-6.393-4.357-10.151-3.807	c-1.987-2.124-4.699-3.373-7.63-3.473c-4.733-0.161-8.814,2.839-10.525,7.018c-2.842,0.654-5.289,2.378-6.847,4.873	c-3.318,5.313-1.284,12.41,4.142,15.543l7.523,4.343c0.493,0.284,1.1,0.285,1.594,0.003l10.245-5.855l-0.021,4.018l-7.902,4.563	c-3.448,1.991-7.945,1.378-10.451-1.715c-0.591-0.73-1.035-1.53-1.336-2.368c-0.212-0.591-0.772-0.982-1.4-0.982h0	c-1.039,0-1.774,1.033-1.421,2.01c0.326,0.901,0.774,1.771,1.344,2.589c2.43,3.487,6.613,5.039,10.645,4.465	c1.987,2.129,4.7,3.381,7.634,3.483c4.736,0.163,8.82-2.838,10.531-7.02c2.841-0.654,5.288-2.378,6.844-4.872	C46.303,27.788,44.269,20.691,38.844,17.559z M34,33.723c0,4.324-3.313,8.077-7.633,8.269c-1.837,0.082-3.585-0.463-5.024-1.496	c0.274-0.13,0.546-0.266,0.812-0.42l7.521-4.342c0.493-0.285,0.799-0.81,0.802-1.38l0.054-9.883c0.003-0.55-0.441-0.999-0.992-1	c-0.549-0.002-0.995,0.441-0.998,0.99l-0.011,2.172L18.498,32.37l-7.918-4.571c-3.745-2.163-5.339-6.908-3.345-10.745	c0.848-1.633,2.196-2.875,3.812-3.605C11.022,13.753,11,14.058,11,14.367v8.684c0,0.569,0.302,1.095,0.794,1.382l8.73,5.055	c0.475,0.275,1.082,0.113,1.358-0.361c0.277-0.476,0.114-1.085-0.362-1.361L14,23.42v-9.143c0-4.325,3.313-8.077,7.634-8.269	c1.835-0.081,3.582,0.462,5.02,1.494c-0.264,0.127-0.526,0.259-0.782,0.407l-7.548,4.357c-0.494,0.285-0.799,0.81-0.802,1.38	l-0.054,9.797c-0.003,0.55,0.441,0.999,0.992,1c0.549,0.002,0.995-0.441,0.998-0.99l0.011-2.087l4.552-2.603L34,24.58V33.723z M40.765,30.946c-0.848,1.633-2.195,2.875-3.812,3.604C36.978,34.248,37,33.944,37,33.636v-8.687c0-0.569-0.302-1.095-0.794-1.382	l-10.191-5.943l3.487-1.994l7.918,4.571C41.165,22.364,42.759,27.109,40.765,30.946z"></path>
                        </svg>`,
                        status: "upgrade"
                    },
                    {
                        key: "gemini_api",
                        label: "Gemini API",
                        logo: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65">
      <mask id="maskme" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="65" height="65">
        <path d="M32.447 0c.68 0 1.273.465 1.439 1.125a38.904 38.904 0 001.999 5.905c2.152 5 5.105 9.376 8.854 13.125 3.751 3.75 8.126 6.703 13.125 8.855a38.98 38.98 0 005.906 1.999c.66.166 1.124.758 1.124 1.438 0 .68-.464 1.273-1.125 1.439a38.902 38.902 0 00-5.905 1.999c-5 2.152-9.375 5.105-13.125 8.854-3.749 3.751-6.702 8.126-8.854 13.125a38.973 38.973 0 00-2 5.906 1.485 1.485 0 01-1.438 1.124c-.68 0-1.272-.464-1.438-1.125a38.913 38.913 0 00-2-5.905c-2.151-5-5.103-9.375-8.854-13.125-3.75-3.749-8.125-6.702-13.125-8.854a38.973 38.973 0 00-5.905-2A1.485 1.485 0 010 32.448c0-.68.465-1.272 1.125-1.438a38.903 38.903 0 005.905-2c5-2.151 9.376-5.104 13.125-8.854 3.75-3.749 6.703-8.125 8.855-13.125a38.972 38.972 0 001.999-5.905A1.485 1.485 0 0132.447 0z" fill="#10cfe3"/>
      </mask>
      <g mask="url(#maskme)">
        <rect width="65" height="65" fill="#10cfe3"/>
      </g>
    </svg>
    `,
                        status: "upgrade"
                    },
                    {
                        key: "claude",
                        label: "Claude",
                        logo: `<svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 509.64"><path fill="#D77655" d="M115.612 0h280.775C459.974 0 512 52.026 512 115.612v278.415c0 63.587-52.026 115.612-115.613 115.612H115.612C52.026 509.639 0 457.614 0 394.027V115.612C0 52.026 52.026 0 115.612 0z"/><path fill="#FCF2EE" fill-rule="nonzero" d="M142.27 316.619l73.655-41.326 1.238-3.589-1.238-1.996-3.589-.001-12.31-.759-42.084-1.138-36.498-1.516-35.361-1.896-8.897-1.895-8.34-10.995.859-5.484 7.482-5.03 10.717.935 23.683 1.617 35.537 2.452 25.782 1.517 38.193 3.968h6.064l.86-2.451-2.073-1.517-1.618-1.517-36.776-24.922-39.81-26.338-20.852-15.166-11.273-7.683-5.687-7.204-2.451-15.721 10.237-11.273 13.75.935 3.513.936 13.928 10.716 29.749 23.027 38.848 28.612 5.687 4.727 2.275-1.617.278-1.138-2.553-4.271-21.13-38.193-22.546-38.848-10.035-16.101-2.654-9.655c-.935-3.968-1.617-7.304-1.617-11.374l11.652-15.823 6.445-2.073 15.545 2.073 6.547 5.687 9.655 22.092 15.646 34.78 24.265 47.291 7.103 14.028 3.791 12.992 1.416 3.968 2.449-.001v-2.275l1.997-26.641 3.69-32.707 3.589-42.084 1.239-11.854 5.863-14.206 11.652-7.683 9.099 4.348 7.482 10.716-1.036 6.926-4.449 28.915-8.72 45.294-5.687 30.331h3.313l3.792-3.791 15.342-20.372 25.782-32.227 11.374-12.789 13.27-14.129 8.517-6.724 16.1-.001 11.854 17.617-5.307 18.199-16.581 21.029-13.75 17.819-19.716 26.54-12.309 21.231 1.138 1.694 2.932-.278 44.536-9.479 24.062-4.347 28.714-4.928 12.992 6.066 1.416 6.167-5.106 12.613-30.71 7.583-36.018 7.204-53.636 12.689-.657.48.758.935 24.164 2.275 10.337.556h25.301l47.114 3.514 12.309 8.139 7.381 9.959-1.238 7.583-18.957 9.655-25.579-6.066-59.702-14.205-20.474-5.106-2.83-.001v1.694l17.061 16.682 31.266 28.233 39.152 36.397 1.997 8.999-5.03 7.102-5.307-.758-34.401-25.883-13.27-11.651-30.053-25.302-1.996-.001v2.654l6.926 10.136 36.574 54.975 1.895 16.859-2.653 5.485-9.479 3.311-10.414-1.895-21.408-30.054-22.092-33.844-17.819-30.331-2.173 1.238-10.515 113.261-4.929 5.788-11.374 4.348-9.478-7.204-5.03-11.652 5.03-23.027 6.066-30.052 4.928-23.886 4.449-29.674 2.654-9.858-.177-.657-2.173.278-22.37 30.71-34.021 45.977-26.919 28.815-6.445 2.553-11.173-5.789 1.037-10.337 6.243-9.2 37.257-47.392 22.47-29.371 14.508-16.961-.101-2.451h-.859l-98.954 64.251-17.618 2.275-7.583-7.103.936-11.652 3.589-3.791 29.749-20.474-.101.102.024.101z"/></svg>`,
                        status: "coming soon"
                    }
                ],
                entitySuggestions: [],
                selectedEntity: null,
                entityLoading: false,
                aiOverviewDialog: false,
                deviceFilter: [0],
                intervalFilter: [0],
                disabled: false,
                deviceTypes: ["mobile", "desktop"],
                intervalTexts: ["daily", "weekly", "every 2 weeks", "monthly"],
                intervalTypes: [1, 7, 14, 28],
                textMap: [
                     {
                        location_text: "United States",
                        country_code: "US",
                        language_code: "en",
                        location_code: 2840,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "China",
                        country_code: "CN",
                        language_code: "zh-CN",
                        location_code: 2156,
                        google_ai_mode_enabled: false
                    },
                    {
                        location_text: "Germany",
                        country_code: "DE",
                        language_code: "de",
                        location_code: 2276,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Japan",
                        country_code: "JP",
                        language_code: "ja",
                        location_code: 2392,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "United Kingdom",
                        country_code: "GB",
                        language_code: "en",
                        location_code: 2826,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "India",
                        country_code: "IN",
                        language_code: "en",
                        location_code: 2356,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "France",
                        country_code: "FR",
                        language_code: "fr",
                        location_code: 2250,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Italy",
                        country_code: "IT",
                        language_code: "it",
                        location_code: 2380,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Russia",
                        country_code: "RU",
                        language_code: "ru",
                        location_code: 2643,
                        google_ai_mode_enabled: false
                    },
                    {
                        location_text: "Brazil",
                        country_code: "BR",
                        language_code: "pt-BR",
                        location_code: 2076,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Canada",
                        country_code: "CA",
                        language_code: "en",
                        location_code: 2124,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Australia",
                        country_code: "AU",
                        language_code: "en",
                        location_code: 2036,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Mexico",
                        country_code: "MX",
                        language_code: "es",
                        location_code: 2484,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Spain",
                        country_code: "ES",
                        language_code: "es",
                        location_code: 2724,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "South Korea",
                        country_code: "KR",
                        language_code: "ko",
                        location_code: 2410,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Turkey",
                        country_code: "TR",
                        language_code: "tr",
                        location_code: 2792,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Indonesia",
                        country_code: "ID",
                        language_code: "en",
                        location_code: 2360,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Netherlands",
                        country_code: "NL",
                        language_code: "nl",
                        location_code: 2528,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Saudi Arabia",
                        country_code: "SA",
                        language_code: "ar",
                        location_code: 2682,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Switzerland",
                        country_code: "CH",
                        language_code: "de",
                        location_code: 2756,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Poland",
                        country_code: "PL",
                        language_code: "pl",
                        location_code: 2616,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Taiwan",
                        country_code: "TW",
                        language_code: "zh-TW",
                        location_code: 2158,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Ireland",
                        country_code: "IE",
                        language_code: "en",
                        location_code: 2372,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Belgium",
                        country_code: "BE",
                        language_code: "nl",
                        location_code: 2056,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Sweden",
                        country_code: "SE",
                        language_code: "sv",
                        location_code: 2752,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Israel",
                        country_code: "IL",
                        language_code: "he",
                        location_code: 2376,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Argentina",
                        country_code: "AR",
                        language_code: "es",
                        location_code: 2032,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Singapore",
                        country_code: "SG",
                        language_code: "en",
                        location_code: 2702,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Austria",
                        country_code: "AT",
                        language_code: "de",
                        location_code: 2040,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "United Arab Emirates",
                        country_code: "AE",
                        language_code: "ar",
                        location_code: 2784,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "United Arab Emirates",
                        country_code: "AE",
                        language_code: "en",
                        location_code: 2784,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Norway",
                        country_code: "NO",
                        language_code: "no",
                        location_code: 2578,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Thailand",
                        country_code: "TH",
                        language_code: "th",
                        location_code: 2764,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Colombia",
                        country_code: "CO",
                        language_code: "es",
                        location_code: 2170,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Vietnam",
                        country_code: "VN",
                        language_code: "en",
                        location_code: 2704,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Malaysia",
                        country_code: "MY",
                        language_code: "en",
                        location_code: 2458,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Philippines",
                        country_code: "PH",
                        language_code: "en",
                        location_code: 2608,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Bangladesh",
                        country_code: "BD",
                        language_code: "bn",
                        location_code: 2050,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Denmark",
                        country_code: "DK",
                        language_code: "da",
                        location_code: 2208,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Romania",
                        country_code: "RO",
                        language_code: "ro",
                        location_code: 2642,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "South Africa",
                        country_code: "ZA",
                        language_code: "en",
                        location_code: 2710,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Hong Kong",
                        country_code: "HK",
                        language_code: "zh-TW",
                        location_code: 2344,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Czechia",
                        country_code: "CZ",
                        language_code: "cs",
                        location_code: 2203,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Slovakia",
                        country_code: "SK",
                        language_code: "sk",
                        location_code: 2703,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Hungary",
                        country_code: "HU",
                        language_code: "hu",
                        location_code: 2348,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Croatia",
                        country_code: "HR",
                        language_code: "hr",
                        location_code: 2191,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Slovenia",
                        country_code: "SI",
                        language_code: "sl",
                        location_code: 2705,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Serbia",
                        country_code: "RS",
                        language_code: "sr",
                        location_code: 2688,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Bosnia and Herzegovina",
                        country_code: "BA",
                        language_code: "bs",
                        location_code: 2070,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Bulgaria",
                        country_code: "BG",
                        language_code: "bg",
                        location_code: 2100,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Egypt",
                        country_code: "EG",
                        language_code: "ar",
                        location_code: 2818,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Chile",
                        country_code: "CL",
                        language_code: "es",
                        location_code: 2152,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Pakistan",
                        country_code: "PK",
                        language_code: "en",
                        location_code: 2586,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Peru",
                        country_code: "PE",
                        language_code: "es",
                        location_code: 2604,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Portugal",
                        country_code: "PT",
                        language_code: "pt",
                        location_code: 2620,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Nigeria",
                        country_code: "NG",
                        language_code: "en",
                        location_code: 2566,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Kazakhstan",
                        country_code: "KZ",
                        language_code: "ru",
                        location_code: 2398,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "Finland",
                        country_code: "FI",
                        language_code: "fi",
                        location_code: 2246,
                        google_ai_mode_enabled: true
                    },
                    {
                        location_text: "New Zealand",
                        country_code: "NZ",
                        language_code: "en",
                        location_code: 2554,
                        google_ai_mode_enabled: true
                    }
                    // {
                    //     location_text: "Russia",
                    //     country_code: "RU",
                    //     language_code: "ru",
                    //     location_code: 2643,
                    //     google_ai_mode_enabled: false
                    // },
                    // {
                    //     location_text: "Brazil",
                    //     country_code: "BR",
                    //     language_code: "pt-BR",
                    //     location_code: 2076,
                    //     google_ai_mode_enabled: true
                    // }
                ],
                entitySuggestRequestId: 0,
                entitySearchText: ""
            }
        },
        computed: {
            // platformItems() {
            //     const aiModeEnabled = !!this.project?.langloc?.google_ai_mode_enabled
            //     return this.platformSelectItems.map((it) => {
            //         if (it.key === "google_ai_mode") {
            //             return { ...it, disabled: !aiModeEnabled }
            //         }
            //         return it
            //     })
            // }
        },
        mounted() {
            this.textMap.sort((a, b) => a.location_text.localeCompare(b.location_text))
        },
        methods: {
            // Standort + Sprache: ein location_code kann mehrfach vorkommen (VAE ar/en), darum nicht nur location_code als Schlüssel
            getLocationKey(item) {
                if (!item) return ""
                return `${item.location_code}-${item.language_code || ""}`
            },
            getLocationText(item) {
                if (!item) return ""
                const location = item.location_text || ""
                const language = item.language_code ? ` (${item.language_code})` : ""
                return `${location}${language}`
            },
            onAiOverviewChange(value) {
                if (value) {
                    this.aiOverviewDialog = true
                }
            },
            async validateDomain() {
                const rawDomain = String(this.project?.domain || "")
                const hasAnyScheme = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//.test(rawDomain)
                const hasAllowedScheme = /^(https?|ftp|smtp):\/\//i.test(rawDomain)
                const hasScheme = hasAllowedScheme

                try {
                    if (hasAnyScheme && !hasAllowedScheme) {
                        console.log("Ungültige Domain: " + rawDomain)
                    } else {
                        const testUrl = hasScheme ? new URL(rawDomain) : null
                        const hostValue = hasScheme ? testUrl.host : rawDomain.split("/")[0]
                        const hostname = hasScheme ? testUrl.hostname : hostValue.split(":")[0]
                        const hostnamePattern = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9-]{2,63}$/i
                        const isValidHostname = hostnamePattern.test(hostname)

                        if (isValidHostname) {
                            console.log("Gültige Domain: " + rawDomain)
                            console.log(hostValue)
                            console.log(hostname)
                        } else {
                            console.log("Ungültige Domain: " + rawDomain)
                        }
                    }
                } catch (error) {
                    console.log("Ungültige Domain: " + rawDomain)
                }
            },
            getIntervalText(interval) {
                return this.intervalTexts[this.intervals.indexOf(interval)]
            },
            async onEntitySearch(val) {
                if (!val || val.length < 2) return

                this.entityLoading = true
                const requestId = ++this.entitySuggestRequestId
                try {
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/ai-suite/entities/suggest"
                    let post_data = {
                        company_id: localStorage.company_id,
                        query: val
                    }
                    let response_data = await this.$helpers.axiosPost(url, post_data)
                    if (requestId === this.entitySuggestRequestId) {
                        this.entitySuggestions = response_data.data.suggestions.map((item, idx) => ({
                            ...item,
                            uniqueKey: item.entityId ? item.entityId + "_" + idx : idx
                        }))
                    }
                } catch (err) {
                    if (requestId === this.entitySuggestRequestId) {
                        this.entitySuggestions = []
                    }
                    console.error("Entity suggest error", err)
                } finally {
                    if (requestId === this.entitySuggestRequestId) {
                        this.entityLoading = false
                    }
                }
            },
            updateGoogleAiModeAvailability() {
                const langloc = this.project?.langloc
                const allowed = !!langloc && langloc.google_ai_mode_enabled !== false
                const idx = this.platformSelectItems.findIndex((i) => i.key === "google_ai_mode")
                if (idx !== -1) {
                    const item = this.platformSelectItems[idx]
                    const newStatus = allowed ? "active" : "not available on selected location"
                    if (item.status !== newStatus) {
                        this.$set(this.platformSelectItems, idx, { ...item, status: newStatus })
                    }
                }
                if (!allowed && Array.isArray(this.project.platforms)) {
                    this.project.platforms = this.project.platforms.filter((k) => k !== "google_ai_mode")
                }
            },
            // Amazon Rufus nur an Standorten mit eigenem Amazon-Marktplatz (siehe AMAZON_RUFUS_LOCATION_CODES)
            updateAmazonRufusAvailability() {
                const allowed = isAmazonRufusLocation(this.project?.langloc)
                const idx = this.platformSelectItems.findIndex((i) => i.key === "amazon_rufus")
                if (idx !== -1) {
                    const item = this.platformSelectItems[idx]
                    const newStatus = allowed ? "active" : "not available on selected location"
                    if (item.status !== newStatus) {
                        this.$set(this.platformSelectItems, idx, { ...item, status: newStatus })
                    }
                }
                if (!allowed && Array.isArray(this.project.platforms)) {
                    this.project.platforms = this.project.platforms.filter((k) => k !== "amazon_rufus")
                }
            },
            updateGoogleAiOverviewAvailability() {
                const langloc = this.project?.langloc
                const allowed = !!langloc && langloc.google_ai_mode_enabled !== false
                const idx = this.platformSelectItems.findIndex((i) => i.key === "google")
                if (idx !== -1) {
                    const item = this.platformSelectItems[idx]
                    const newStatus = allowed ? "active" : "not available on selected location"
                    if (item.status !== newStatus) {
                        this.$set(this.platformSelectItems, idx, { ...item, status: newStatus })
                    }
                }
                if (!allowed && Array.isArray(this.project.platforms)) {
                    this.project.platforms = this.project.platforms.filter((k) => k !== "google")
                }
            }
        },
        watch: {
            entitySearchText(val) {
                // Nur suchen, wenn der Text nicht durch Auswahl gesetzt wurde
                if (typeof val === "string" && val.length >= 2) {
                    this.onEntitySearch(val)
                }
            },
            selectedEntity(val) {
                if (val && val.uniqueKey) {
                    this.project.brand = val
                } else {
                    this.project.brand = null
                }
            },
            deviceFilter(val) {
                this.project.device = this.deviceTypes[val]
            },
            intervalFilter(val) {
                this.project.interval = this.intervalTypes[val]
            },
            "project.langloc": {
                handler() {
                    this.updateGoogleAiModeAvailability()
                    this.updateGoogleAiOverviewAvailability()
                    this.updateAmazonRufusAvailability()
                },
                immediate: true
            }
        }
    }
</script>

<style></style>
